// extracted by css-extract-rspack-plugin
export default {"split":"split-l6lnTD","content":"content-umuhXo","media":"media-neQDU6","column":"column-eypGgg"};